<template>
  <el-container class="esb-container" v-show="!$store.state['user-state'].isVerified">
    <esbSidenav></esbSidenav>
    <el-container id="content-main-container" style="height: 100vh; overflow-y: auto;background-color: #f0f0f0;color: #1b1e21; ">
      <el-header class="p-0 m-0 w-100" style="height: 50px;">
        <el-col  style="width: calc(100%);float: right">
          <esb-header style="min-width: 1100px !important;"></esb-header>
        </el-col>
      </el-header>

      <el-col>
        <el-main id="app-main-contain" class="m-0 pl-3 pt-1 pr-4" style="width: calc(100% - 10px);float: right">
           
          <transition name="slide-fade" class="h-100">
            
            <router-view :key="$route.fullPath"></router-view>
             
          </transition>
        </el-main>
      </el-col>
    </el-container>
    <!--<el-col :span="24">
        <esb-breadcrumb></esb-breadcrumb>
    </el-col>-->
  </el-container>
</template>

<script>
  import Vue from "vue";
  import "ag-grid-community/dist/styles/ag-grid.css";
  import "devegram-vue-data-collecter-eui/src/css/style.css"
  import "ag-grid-community/dist/styles/ag-theme-bootstrap.min.css";
  import "ag-grid-community/dist/styles/ag-theme-material.min.css";
  import "devegram-vue-data-collecter-eui/src/export.js"
  import 'element-ui/lib/theme-chalk/index.css';
  import 'element-ui/lib/theme-chalk/display.css';
  import Paginate from 'vuejs-paginate'
  import ElementUI from 'element-ui';
  import lang from 'element-ui/lib/locale/lang/en'
  import locale from 'element-ui/lib/locale'
  import '@/components/export'
  locale.use(lang)
  $vue.use(ElementUI);
  $vue.component('paginate', Paginate)


  import esbSidenav from './layout/sidenav/View'
  import esbHeader from './layout/header/View'
  export default {
    components: {
      esbSidenav,
      esbHeader
    },
    data () {
      return {
        controller: this
      }
    },
    mounted() {
      let styles = [
        'https://fonts.googleapis.com/css2?family=Open+Sans:wght@300&display=swap'
      ]

      for (let x in styles) {
        let element = document.createElement("link");
        element.setAttribute("rel", "stylesheet");
        element.setAttribute("type", "text/css");
        element.setAttribute("portal", "portal-cpanel");
        element.setAttribute("href", styles[x]);
        document.getElementsByTagName("head")[0].appendChild(element);
      }


      setTimeout(() => {
        if ($store.getters['user-state/isAuthenticated']) {
          let links = document.querySelectorAll('[portal]');
          links.forEach( (l) => {
            if (l.getAttribute('portal') == 'portal-home') {
              l.parentNode.removeChild(l)
            }
          })
        }
      }, 200)
    }
  };
</script>

<style scoped>
  .slide-fade-enter-active {
    transition: all .5s ease-out;
  }
  .slide-fade-leave-active {
    transition: all .8s cubic-bezier(1.5, 0.5, 0.8, 0);
  }

  /* .slide-fade-leave-active below version 2.1.8 */

  .slide-fade-enter, .slide-fade-leave-to {
    transform: translateX(-25px);
    opacity: 0;
    overflow: hidden;
  }
</style>

<style data-portal="portal-home" lang="css" src="@/modules-config/css/style.css"></style>
<style data-portal="portal-home" lang="css" src="@/../public/css/bootstrap.min.css"></style>
